'use strict';

module.exports = require('./lib')



//////////////////
// WEBPACK FOOTER
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/~/promise/index.js
// module id = ../../../../promise/index.js
// module chunks = 38